import React from "react";
import axios from "axios";
import { Button, Dropdown, Loader, Segment } from "semantic-ui-react";
import { Instant } from "js-joda";
import moment from "moment";
import DateRangePicker from "../components/DateRangePicker";
import { getAuthHttpHeaders } from "../auth";
import VolumeStatsChart from "./VolumeStatsChart";
import { ExchangeType } from "../constants";

class VolumeStats extends React.Component {
  state = {
    counter: "BTC",
    endDate: moment().startOf("day"),
    startDate: moment()
      .startOf("day")
      .subtract(2, "M"),
  };

  load = async (counter, startDate, endDate) => {
    if (this.loading) return;

    const startInstant = Instant.ofEpochSecond(startDate.unix());
    const endInstant = Instant.ofEpochSecond(endDate.unix());

    console.debug(`Loading volume stats ${startDate} (${startInstant}), end ${endDate} (${endInstant})`);

    this.loading = true;
    this.setState({ loading: true });

    try {
      const axiosRequest = axios.create({
        baseURL: "api",
        timeout: 60 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
        params: {
          counter: this.state.counter,
          start: startDate.unix(),
          end: endDate.unix(),
        },
      });

      const response = await axiosRequest.get("chart/loadvolumestats");
      const volumeData = response.data;

      if (!Array.isArray(volumeData)) {
        console.error("Error loading volume stats: " + JSON.stringify(volumeData));
      }

      this.setState({ volumeData, loading: false });
      this.loading = false;
    } catch (e) {
      alert(e);
    }
  };

  static prepareCounterOptions() {
    return ["BTC", "ETH"].map(e => {
      return {
        text: e,
        value: e,
      };
    });
  }

  static groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach(item => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  };

  onCounterChanged = (e, { value }) => this.setState({ counter: value });

  onDateRangeChanged = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  render() {
    const { volumeData, counter, startDate, endDate, loading } = this.state;

    const charts = [];

    if (!volumeData) {
      if (counter && startDate.isBefore(endDate)) this.load(counter, startDate, endDate);
    } else {
      const groupedData = VolumeStats.groupBy(volumeData, d => d.exchange);

      const exchangeTypes = Object.values(ExchangeType).sort();
      exchangeTypes.forEach((exchange, i) => {
        const exchangeData = groupedData.get(exchange);
        if (exchangeData) {
          charts.push(<VolumeStatsChart key={exchange} exchange={exchange} volumeData={exchangeData} />);
        }
      });
    }

    return (
      <div>
        <Segment>
          <Dropdown
            value={counter}
            selection
            style={{ marginRight: "6px" }}
            options={VolumeStats.prepareCounterOptions()}
            onChange={this.onCounterChanged}
          />
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            style={{ marginRight: "6px" }}
            onChange={this.onDateRangeChanged}
          />
          <Button secondary icon="download" onClick={() => this.setState({ volumeData: null })} />
        </Segment>
        <Loader active={loading} />
        {volumeData ? <div>{charts.length === 0 ? <h3>No data!</h3> : charts}</div> : null}
      </div>
    );
  }
}

export default VolumeStats;



// WEBPACK FOOTER //
// ./src/charts/VolumeStats.js